import { useContext, useEffect, useState } from 'react';
import { useModal } from 'src/services/modal';
import AuthContext from 'src/store/auth-context';
import { QUALIFYING_TAX_AMNT } from 'src/constants/global';
import formatter from 'src/util/currencyFormatter';
import { Link } from 'react-router-dom';
import MessageModal from 'src/components/modal/MessageModal';

/**
 * A modal component that displays a message for skipping itemization
 *
 * @returns {JSX.Element} A modal component
 */

const SkipItemizationMessageModal = () => {
  const modal = useModal();
  const { account } = useContext(AuthContext);
  const { openModal, closeModal, open } = modal;
  const { bypassItemization } = account;
  const [beenOpened, setBeenOpened] = useState(false);

  const message = (
    <>
      You have declared that your total aggregate business taxable value is{' '}
      {formatter.format(QUALIFYING_TAX_AMNT)} or less and have chosen to not itemize your business
      assets, and leased equipment. You may proceed directly to:{' '}
      <Link to="/review">Step 5 - Review</Link>. If you want to change your filing method please go
      back to: <Link to="/home">Step 1 - Home</Link>.
    </>
  );

  useEffect(() => {
    if (bypassItemization === 'Y' && beenOpened === false) {
      openModal();
      setBeenOpened(true);
    }
  }, [openModal, bypassItemization, beenOpened, setBeenOpened]);

  return <MessageModal message={message} handleClose={closeModal} open={open} />;
};

export default SkipItemizationMessageModal;
